import styled from "@emotion/styled"
import { ShadowContainer } from "../../../../styled/layout.styled"

export const IdeaCreateStockOrSectorContainer = styled(ShadowContainer)({
  padding: "10px",
})
